import React from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import { Colors } from "baseStyles/enums/colors";
import MergeStudentStyles from "./styles";
import { ChildWithImage } from "./childWithImage";
import ReplaceIcon from './../assets/replace-icon.svg';
import { ChildWithoutImage } from "./childWithoutImage";
import Button from "schoolUiComponents/basic/Button";
import AlertIcon from './../assets/alert-icon.svg';
import { FlexProps } from "../../schoolUiComponents/basic/Box/FlexBox/types";
import { APIS } from "../api";
import { interactedAddreplaceStudentProfileScreenEvent, ptlLinkingAttemptedEvent } from "../events";
import { IChild, IReferralData } from ".";
import Box from "../../schoolUiComponents/basic/Box";
import StringUtility from "utility/string";


export const ReplaceChild = ({ existingChild, replaceChild, newChild, selectExistingChild, setShowSuccessPopup, parentInfo, showNewChild, showPrimary, setOptionSelected, referralData } : { existingChild : IChild[], replaceChild: IChild, newChild: IChild, selectExistingChild: (child: IChild) => void, setShowSuccessPopup: React.Dispatch<React.SetStateAction<boolean>>, parentInfo: any, showNewChild: boolean, showPrimary: boolean, setOptionSelected: React.Dispatch<React.SetStateAction<string>>, referralData : IReferralData  }) => {
    const styles = MergeStudentStyles();

    return (
        <FlexBox column padding={24} borderRadius={24} backgroundColor={Colors.WHITE_2} gap={24} {...styles.newChild}>
            <FlexBox column gap={8} fullWidth>
                <Text.H3 color={Colors.BLACK} emphasis lines={2} center fullWidth >Replace existing student profile</Text.H3>
                {!showNewChild && (existingChild?.length == 1) && <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY} lines={2} fullWidth center>Replace {StringUtility.formatFullName(existingChild?.[0]?.first_name, existingChild?.[0]?.last_name)} with {StringUtility.formatFullName(newChild?.first_name, newChild?.last_name)} if they are the same student.</Text.SMALL>}
                {(existingChild?.length >= 2) && <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY} lines={2} fullWidth center>Select a student profile to replace.</Text.SMALL>}
            </FlexBox>
            {
                existingChild.length == 1 ?
                    <FlexBox gap={8} flex={1}>
                        <ChildWithImage child={existingChild[0]} />
                        <ReplaceIcon />
                        <ChildWithImage child={newChild} />
                    </FlexBox> :
                    <FlexBox gap={8} flex={1}>
                        <FlexBox gap={16} column>
                            {existingChild.map((child :any) => (<ChildWithoutImage child={child} key={child.id} selectExistingChild={selectExistingChild} replaceChild={replaceChild} existingChild={existingChild} referralData = {referralData} />))}
                        </FlexBox>
                        <ReplaceIcon />
                        <ChildWithImage child={newChild} />

                    </FlexBox>
            }
            {replaceChild ? <FlexBox padding={"6px 12px"} gap={12} backgroundColor={Colors.LIGHT_YELLOW_2} fullWidth noWrap alignItems={FlexProps.AlignItems.FLEX_START}>
                <FlexBox padding={2}><AlertIcon /></FlexBox>
                <FlexBox width = {"calc(100% - 28px)"}>
                    <Text.SMALL color={Colors.CONTENT_NOTICE_ALERT_WBG} lines={3} fullWidth>This action will delete {StringUtility.formatFullName(replaceChild.first_name, replaceChild.last_name)}’s profile permanently.</Text.SMALL>
                </FlexBox>
            </FlexBox> : null}
            <Button.M
                disabled={!replaceChild}
                onClick={() => {
                const queryParams = new URLSearchParams(window.location.search);
                const referral_type = queryParams.get("referral_type");
                const referrer_code = queryParams.get("referrer_code");
                const tr_sub_source = queryParams.get("tr_sub_source");
                const trd_id = queryParams.get("trd_id");
                interactedAddreplaceStudentProfileScreenEvent({ clickedOn: "Replace profile", linkedStudentCount: existingChild.length.toString(), grade: newChild.grade_code, ...referralData });
                ptlLinkingAttemptedEvent({ linkedStudentCount: existingChild.length.toString(), optionsSelected: ["Replace profile"], grade: newChild.grade_code, ...referralData })
                setOptionSelected("Replace profile");
                APIS.replaceChild({new_student_id: newChild.id, replace_student_id: replaceChild.id, referral_type, referrer_code, tr_sub_source, trd_id}).then((res) => {
                    setShowSuccessPopup(true);
                    setTimeout(() => {
                        // [AI GENERATED CODE] Post-login student merge — tag session with parent_signin
                        if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('parent_signin');
                        window.location.href='/parent-dashboard';
                    }, 3000)
                }).catch((err) => {
                    showFlashMessage(err?.response?.data?.error || "Something went wrong!", "error");
                })
            }} bordered = {showNewChild} primary = {!showNewChild}><Text.H4 color={showNewChild ? Colors.NAVY_BLUE : Colors.WHITE}>Replace profile</Text.H4></Button.M>
            {!showNewChild && <Box margin={"10px auto"} onClick={() => {
                interactedAddreplaceStudentProfileScreenEvent({ clickedOn: "Use different email", linkedStudentCount: existingChild.length.toString(), grade: newChild.grade_code, ...referralData });
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.delete("new_ptl_flow");
                searchParams.append("masked_email", parentInfo?.email);
                window.location.href = `/ptl-setup?${searchParams}`;
            }}><Text.H4 noUnderline cta>Use different email</Text.H4></Box>}
        </FlexBox>
    )
}